const Banner = () => null;

export default Banner;
